// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2eWA6","bigColWidth":"Table_bigColWidth__1OM7I","biggerColWidth":"Table_biggerColWidth__3zx0Y","row":"Table_row__Kw1zD","col":"Table_col__3nyfi"};